export const storeMapCenterPostion = {
  // coordinates of Brussels
  lat: 50.85045,
  lng: 4.24878,
};
